import { render, staticRenderFns } from "./UpdateEmployeeDetailModal.vue?vue&type=template&id=44cac7fa&"
import script from "./UpdateEmployeeDetailModal.vue?vue&type=script&lang=js&"
export * from "./UpdateEmployeeDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports